import React, { useEffect, useMemo, useState } from 'react'
import { Tree } from 'antd'
import { isArray } from 'lodash-es'
import { SAside } from 'shj-components'

const TreeSelect: React.FC = (props: any) => {
  const { treeData, setSelectedKeys, selectedKeys } = props
  const [treeList, setTreeList] = useState<any>([])
  // console.log(selectedKeys, 'selectedKeys')
  useEffect(() => {
    if (treeData && treeData.length > 0) {
      let newData: Array<any> = treeDataHandle(treeData) || []
      // console.log(newData, 'newData')
      setTreeList([...newData])
    }
  }, [treeData])
  const treeDataHandle = treeData => {
    if (isArray(treeData)) {
      treeData.forEach((item: any) => {
        if (item.children) {
          item.selectable = false
          treeDataHandle(item.children)
        } else {
          item.selectable = true
        }
      })
      return treeData
    }
  }
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([])
  const onExpand = (newExpandedKeys: React.Key[]) => {
    setExpandedKeys(newExpandedKeys)
  }

  const onSelect = (e: any) => {
    setSelectedKeys([...e])
  }

  return (
    <div style={{ width: 200 }}>
      {/* <Tree
        key={selectedKeys}
        onExpand={onExpand}
        expandedKeys={expandedKeys}
        autoExpandParent={true}
        treeData={treeList}
        defaultSelectedKeys={selectedKeys}
        onSelect={onSelect}
        selectable={true}
        blockNode // 是否节点占据一行
        fieldNames={{
          title: 'label',
          key: 'id',
          children: 'children',
        }}
      /> */}
      <SAside
        title="分类"
        treeData={treeList}
        header={false}
        dropItems={false}
        onSelect={onSelect}
        selectable={true}
        selectedKeys={selectedKeys}
        autoExpandParent={true}
        fieldNames={{
          title: 'label',
          key: 'id',
          children: 'children',
        }}
      />
    </div>
  )
}

export default TreeSelect
